<template>
  <div class="layout">
    <header class="fusion-header-wrapper" ref="headerfix">
      <div class="fusion-header">
        <div class="topwrap">
          <div class="topbar">
            <div class="topleft">
              One of the top Asian dermatological symposium
            </div>
            <!-- 로그인시 나타남 -->
            <div v-if="isUserLoggedIn && isLiveOpen" class="btns">
              <a href="https://www.koreaderma.org/streaming" class="btn"
                >Online Live</a
              >
              <a
                href="https://xn--vb0bz3y9vbc6qsyab49c.com/vod/en"
                class="btn"
                target="_blank"
                >Online Sponsored Lectures</a
              >
            </div>

            <div v-if="isUserLoggedIn" class="topright">
              <!-- <a href="/blog/search" class="btn" target="_blank">Meet Our Speakers</a> -->
              <router-link class="tlogin" to="/account/myaccount">
                <img
                  src="@/assets/img/user.png"
                  alt=""
                  height="25"
                  class="userimg"
                />
                <span>Account</span>
              </router-link>
              <a href="javascript:;" @click="logout" class="tlogin tsign"
                >Log out</a
              >
            </div>

            <!-- 미로그인시 -->
            <div v-else class="topright">
              <router-link class="tlogin" to="/login">Log in</router-link>
              <router-link class="tlogin tsign" to="/signup"
                >Sign up</router-link
              >
            </div>
          </div>
          <div class="fusion-row">
            <div class="fusion-logo">
              <router-link to="/">
                <img
                  src="@/assets/img/logo.png"
                  alt="코리아더마2025로고"
                  class="dn"
                />
                <img
                  src="@/assets/img/mnewlogo1.png"
                  alt="코리아더마2025로고"
                  class="mob_logo"
                />
              </router-link>
            </div>

            <nav class="fusion-main-menu">
              <ul id="menu-main-menu" class="fusion-menu">
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/registration') }"
                >
                  <a href="javascript:void(0)">Registration</a>
                  <!-- 서브메뉴 -->
                  <ul class="sub-menu">
                    <li>
                      <router-link to="/registration/guide">Guide</router-link>
                      <router-link to="/registration/register"
                        >Register</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/program') }"
                >
                  <a href="javascript:void(0)">Program</a>
                  <ul class="sub-menu">
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >Detailed Program</a
                      > -->
                      <router-link to="/program/detailed"
                        >Detailed Program</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/speaker') }"
                >
                  <a href="javascript:void(0)">Speaker</a>
                  <ul class="sub-menu">
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >Our Speakers</a
                      > -->
                      <router-link to="/speaker/ourspeakers"
                        >Our Speakers</router-link
                      >
                    </li>
                    <li>
                      <a href="javascript:;" @click="alertBecomeSpeaker()"
                        >Become a Speaker</a
                      >
                      <!-- <router-link
                        to="/speaker/becomespeaker"
                        v-if="isUserLoggedIn"
                        >Become a Speaker</router-link
                      >
                      <a href="javascript:;" v-else @click="checkLogin()"
                        >Become a Speaker</a
                      > -->
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/venue') }"
                >
                  <a href="javascript:void(0)">Venue</a>
                  <ul class="sub-menu">
                    <li>
                      <router-link to="/venue/venueinfo"
                        >Venue Information</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/venue/access"
                        >Access to the Venue</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/abstract') }"
                >
                  <a href="javascript:void(0)">Abstract</a>
                  <ul class="sub-menu">
                    <li>
                      <router-link to="/abstract/guideline"
                        >Guideline</router-link
                      >
                    </li>
                    <li
                      v-if="
                        (role == 'PARTICIPANTS' || role == 'FREECOMM') &&
                        isSubmittable
                      "
                    >
                      <router-link to="/applyforlecturesNew/0/abstract"
                        >General Abstract Submission</router-link
                      >
                    </li>
                    <!-- <li v-if="(role == 'PARTICIPANTS' || role == 'FREECOMM')">
                                            <router-link to="/applyforlecturesNew/0/abstract">General Abstract Submission</router-link>
                                        </li> -->
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()">E-Poster</a> -->
                      <router-link to="/abstract/e-poster"
                        >E-Poster</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/sponsor') }"
                >
                  <a href="javascript:void(0)">Sponsor</a>
                  <ul class="sub-menu">
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >Our Sponsors</a
                      > -->
                      <router-link to="/sponsor/oursponsors"
                        >Our Sponsors</router-link
                      >
                    </li>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()">Sponsorship</a> -->
                      <router-link to="/sponsor/sponsorship"
                        >Sponsorship</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/event') }"
                >
                  <a href="javascript:void(0)">Event</a>
                  <ul class="sub-menu">
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()">Gala</a> -->
                      <router-link to="/event/gala">Gala</router-link>
                    </li>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >Engagement Event</a
                      > -->
                      <router-link to="/event/engagement"
                        >Engagement Event</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li
                  class="menu-item"
                  :class="{ active: $route.path.startsWith('/travelinfo') }"
                >
                  <a href="javascript:void(0)">Travel Info</a>
                  <ul class="sub-menu">
                    <li>
                      <router-link to="/travelinfo/aboutseoul"
                        >About SEOUL</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/travelinfo/themedtrip"
                        >Themed Trip</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/travelinfo/bookinghotel"
                        >Booking Hotel</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/travelinfo/usefulinform"
                        >Useful Info.</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>

            <!-- 모바일 -->
            <div class="fusion-mobile-menu">
              <div class="fusion-mobile-menu-icon">
                <button class="fusion-mobile-selector" @click="toggleMenu">
                  <span>Go to...</span>
                  <i class="pi pi-bars"></i>
                </button>
              </div>
              <ul v-if="menuOpen">
                <li>
                  <a href="javascript:void(0)">
                    <span>Registration</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <router-link to="/registration/guide" @click="toggleMenu"
                        >- Guide</router-link
                      >
                      <router-link
                        to="/registration/register"
                        @click="toggleMenu"
                        >- Register</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Program</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <ul>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >- Detailed Program</a
                      > -->
                      <router-link to="/program/detailed" @click="toggleMenu"
                        >- Detailed Program</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Speaker</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >- Our Speakers</a
                      > -->
                      <router-link to="/speaker/ourspeakers" @click="toggleMenu"
                        >- Our Speakers</router-link
                      >
                    </li>
                    <li>
                      <a href="javascript:;" @click="alertBecomeSpeaker()"
                        >- Become a Speaker</a
                      >
                      <!-- <router-link
                        to="/speaker/becomespeaker"
                        @click="toggleMenu"
                        v-if="isUserLoggedIn"
                        >- Become a Speaker</router-link
                      >
                      <a href="javascript:;" v-else @click="checkLogin()"
                        >- Become a Speaker</a
                      > -->
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Venue</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <router-link to="/venue/venueinfo" @click="toggleMenu"
                        >- Venue Information</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/venue/access" @click="toggleMenu"
                        >- Access to the Venue</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Abstract</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <router-link to="/abstract/guideline" @click="toggleMenu"
                        >- Guideline</router-link
                      >
                    </li>
                    <li
                      v-if="
                        (role == 'PARTICIPANTS' || role == 'FREECOMM') &&
                        isSubmittable
                      "
                    >
                      <router-link to="/applyforlecturesNew/0/abstract"
                        >General Abstract Submission</router-link
                      >
                    </li>
                    <!-- <li v-if="(role == 'PARTICIPANTS' || role == 'FREECOMM')">
                                            <router-link to="/applyforlecturesNew/0/abstract">General Abstract Submission</router-link>
                                        </li> -->
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()">- E-Poster</a> -->
                      <router-link to="/abstract/e-poster" @click="toggleMenu"
                        >- E-Poster</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Sponsor</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >- Our Sponsors</a
                      > -->
                      <router-link to="/sponsor/oursponsors" @click="toggleMenu"
                        >- Our Sponsors</router-link
                      >
                    </li>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()">- Sponsorship</a> -->
                      <router-link to="/sponsor/sponsorship" @click="toggleMenu"
                        >- Sponsorship</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Event</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()">- Gala</a> -->
                      <router-link to="/event/gala" @click="toggleMenu"
                        >- Gala</router-link
                      >
                    </li>
                    <li>
                      <!-- <a href="javascript:;" @click="alertMenu()"
                        >- Engagement Event</a
                      > -->
                      <router-link to="/event/engagement" @click="toggleMenu"
                        >- Engagement Event</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0)">
                    <span>Travel Info</span>
                    <i class="pi pi-angle-down"></i>
                  </a>
                  <!-- 서브메뉴 -->
                  <ul>
                    <li>
                      <router-link
                        to="/travelinfo/aboutseoul"
                        @click="toggleMenu"
                        >- About SEOUL</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/travelinfo/themedtrip"
                        @click="toggleMenu"
                        >- Themed Trip</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/travelinfo/bookinghotel"
                        @click="toggleMenu"
                        >- Booking Hotel</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/travelinfo/usefulinform"
                        @click="toggleMenu"
                        >- Useful Info.</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>

    <router-view></router-view>

    <!-- scrolltop -->
    <Transition name="display">
      <a
        href="javascript:void(0)"
        id="toTop"
        @click="scrollToTop"
        v-show="showScrollButton"
        ref="toTop"
      >
        <i class="pi pi-angle-up"></i>
      </a>
    </Transition>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/layout/Footer.vue";
import { supabase } from "@/API/supabase";

export default {
  name: "Layout",
  data() {
    return {
      showScrollButton: false,
      menuOpen: false,
      isUserLoggedIn: false,
      routeName: "",
      useruid: "",
      role: "",
      isSubmittable: false,
      isLive: true,
      isLiveOpen: false, // 라이브 오픈 여부
    };
  },
  components: {
    Footer,
  },
  async created() {
    this.routeName = this.$router.currentRoute.value.name;

    // 인증 상태 변경 이벤트를 감지하여 처리합니다.
    supabase.auth.onAuthStateChange((event, session) => {
      // 사용자가 로그인한 경우 / 회원가입 페이지 이외의 페이지에서만 실행
      if (
        !this.routeName.includes("signup") &&
        !this.routeName.includes("login")
      ) {
        // console.log(event);
        // console.log(session);
        if (event === "SIGNED_IN") {
          // console.log('사용자가 로그인했습니다.');

          this.checkUserAccount(
            session.user.user_metadata,
            session.access_token,
            session.refresh_token,
            session.user.id,
            session.user.app_metadata.provider
          );
        } else if (event === "SIGNED_OUT") {
          // console.log('사용자가 로그아웃했습니다.');
          this.handlePostLogoutActions();
        }
      }
    });
  },
  async mounted() {
    var user = this.$store.getters["user"];
    if (user.loggedIn) {
      this.isUserLoggedIn = true;
      this.useruid = user.data.useruid;
      await this.getUserInfo();

      this.event_code = await this.getEventCode();
      this.checkApplicationDate();
    } else {
      this.isUserLoggedIn = false;
      this.useruid = "";
    }

    // 라이브 오픈 여부 확인
    this.checkLivePeriod();

    this.emitter.on("watchLoginChange", this.onWatchLoginChange);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    this.emitter.off("watchLoginChange", this.onWatchLoginChange);
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    async $route(to, from) {
      await this.handleRouteChange();
    },
  },
  methods: {
    // 라이브 오픈 기간 체크
    async checkLivePeriod() {
      // 현재 UTC 시각
      const now = new Date();

      // 비교할 시작/종료 시간 (한국시간을 UTC로 변환) - 10/31(금) 07:00 ~ 19:00
      const start1 = new Date("2025-10-31T07:00:00+09:00");
      const end1 = new Date("2025-10-31T19:00:00+09:00");

      // 비교할 시작/종료 시간 (한국시간을 UTC로 변환) - 11/1(토) 07:00 ~ 19:00
      const start2 = new Date("2025-11-01T07:00:00+09:00");
      const end2 = new Date("2025-11-01T19:00:00+09:00");

      // 비교할 시작/종료 시간 (한국시간을 UTC로 변환) - 리허설용 - 10/30(목) 17:00 ~ 10/31(금) 02:00
      const start3 = new Date("2025-10-30T17:00:00+09:00");
      const end3 = new Date("2025-10-31T02:00:00+09:00");

      // UTC 기반 비교 (Date 객체끼리는 내부적으로 UTC 기준 비교)
      this.isLiveOpen =
        (now >= start1 && now <= end1) ||
        (now >= start2 && now <= end2) ||
        (now >= start3 && now <= end3);
    },

    async handleRouteChange() {
      var user = this.$store.getters["user"];
      if (user.loggedIn) {
        this.isUserLoggedIn = true;
        this.useruid = user.data.useruid;
        await this.getUserInfo();

        this.event_code = await this.getEventCode();
        this.checkApplicationDate();
      } else {
        this.isUserLoggedIn = false;
        this.useruid = "";
      }

      this.checkLivePeriod();
    },

    // 사용자 정보 가져오기
    async getUserInfo() {
      try {
        const { data, error } = await supabase
          .from("UserInfo")
          .select("role")
          .eq("useruid", this.useruid)
          .single();

        if (error) {
          console.error("사용자 정보를 불러오는 중 오류 발생:", error);
        } else {
          // console.log("UserInfo : ",data);
          var userData = data;
          this.role = userData.role;
        }
      } catch (error) {
        console.error("사용자 정보를 불러오는 중 오류 발생:", error);
      }
    },

    // 이벤트 코드 가져오기
    async getEventCode() {
      let query = supabase
        .from("Event")
        .select("*")
        .eq("active", true)
        .order("event_code", { ascending: false })
        .limit(1)
        .single();

      const { data, error } = await query;

      // console.log(data);
      if (data) {
        this.activatedEventCodeInfo = data;
        return data.event_code;
      } else {
        return new Date().getFullYear().toString();
      }
    },

    // 신청기간 체크
    async checkApplicationDate() {
      var today = new Date();
      today.setHours(today.getHours() + 9);
      today = new Date(today);

      const { data, error } = await supabase
        .from("Event")
        .select("*")
        .eq("event_code", this.event_code.toString())
        .single();

      if (error) {
        console.log("error", error);
      } else {
        // console.log(data);
        // console.log(this.role)

        if (this.role == "PARTICIPANTS" || this.role == "FREECOMM") {
          var abstract_sdate = new Date(data.abstract_sdate);
          var abstract_edate = new Date(data.abstract_edate);
          if (today < abstract_sdate || today > abstract_edate) {
            this.isSubmittable = false;
          } else {
            this.isSubmittable = true;
          }
        }

        return true;
      }
    },

    // 사용자 계정 체크
    async checkUserAccount(
      session,
      accessToken,
      refreshToken,
      useruid,
      provider
    ) {
      try {
        // console.log("사용자 계정 체크", session);

        const email = session.email;
        const username = session.full_name;

        // 1️⃣ 이메일로 사용자 정보 조회
        let { data: user, error } = await supabase
          .from("UserInfo") // 사용자 테이블명
          .select("*")
          .eq("email", email)
          .single();

        if (error && error.code !== "PGRST116") {
          console.error("사용자 조회 오류:", error);
          throw new Error("사용자 계정을 확인할 수 없습니다.");
        }

        if (user) {
          // 2️⃣ 기존 사용자일 경우
          // console.log("기존 사용자:", user);

          const userInfo = {
            accessToken,
            refreshToken,
            email,
            useruid: user.useruid, // DB의 useruid
            profileComplete: user.lastname ? true : false,
          };
          this.setUserInfo(userInfo);
        } else {
          // 3️⃣ 신규 사용자 회원가입
          // console.log("신규 사용자 등록 진행");

          var today = new Date();
          today.setHours(today.getHours() + 9);
          today = new Date(today);

          var source = "";
          switch (provider) {
            case "google":
              source = "Google";
              break;
            case "facebook":
              source = "Facebook";
              break;
            case "linkedin_oidc":
              source = "LinkedIn";
              break;
            case "email":
              source = "Default form";
              break;
          }

          if (source != "" && source != "Default form") {
            const { data, error: insertError } = await supabase
              .from("UserInfo") // 사용자 테이블명
              .insert([
                {
                  useruid,
                  email,
                  firstname: username,
                  source: source,
                  join_date: today,
                },
              ])
              .select()
              .single();

            if (insertError) {
              console.error("회원가입 오류:", insertError);
              this.logout();
              throw new Error("로그인에 실패했습니다.");
            }

            // console.log("회원가입 완료:", data);

            const userInfo = {
              accessToken,
              refreshToken,
              email,
              useruid,
              profileComplete: false,
            };
            this.setUserInfo(userInfo);
          }
        }
      } catch (error) {
        alert(error.message);
      }
    },

    // 사용자 정보 셋팅
    setUserInfo(userInfo) {
      this.$store.commit("setLoggedIn", true);
      this.$store.commit("setUser", userInfo);

      this.onWatchLoginChange();
    },

    // 로그인 상태 변경 감지
    onWatchLoginChange() {
      var user = this.$store.getters["user"];
      if (user.loggedIn) {
        this.isUserLoggedIn = true;
        this.useruid = user.data.useruid;
      } else {
        this.isUserLoggedIn = false;
        this.useruid = "";
      }
    },

    // 로그아웃
    async logout() {
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error("로그아웃 에러:", error.message);
      } else {
        //console.log('로그아웃 성공');
        // 로그아웃 후에 실행할 작업 수행
        this.handlePostLogoutActions();
      }
    },

    // 로그아웃 후 실행
    handlePostLogoutActions() {
      this.$store.commit("logoutUser");
      this.$router.push("/");
      this.isUserLoggedIn = false;
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 200; // 스크롤이 200px 이상일 때 스크롤탑 버튼 표시
      // show 클래스 추가해서 애니메이션 효과
      if (window.scrollY > 200) {
        this.$refs.toTop.classList.add("show");
        this.$refs.headerfix.classList.add("fixed");
      } else {
        this.$refs.toTop.classList.remove("show");
        this.$refs.headerfix.classList.remove("fixed");
      }
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },

    Nolink() {
      alert("Available soon");
    },

    alertMenu() {
      alert("Available soon");
    },

    alertBecomeSpeaker() {
      alert(
        "The application period has ended.\nThank you for your interest in KOREADERMA 2025."
      );
    },

    checkLogin() {
      alert("Please log-in to proceed.");
      this.$router.push("/login");
      return false;
    },
  },
};
</script>
